import { IPublicClientApplication, AccountInfo } from "@azure/msal-browser";
import { IEmployeeApiService } from "services/models/ApiService";
import { ApiService } from "./ApiService";
import { authorizedFetch, authorizedFetchAsJson } from "./misc";

export class EmployeeApiService implements IEmployeeApiService {
  constructor(private accessToken: () => Promise<string>) {}
  getPermissions(): Promise<string[]> {
    return authorizedFetchAsJson(`${ApiService.v1Url}/employee/permissions?applicationKey=patron360`, this.accessToken);
  }
}
